<template>
<div>
    <navigation :color="color" :flat="flat" />
    <home />
    <about />
     <download />
      <contact />
</div>
</template>

<script>

import navigation from "../components/Navigation";
import home from "../components/HomeSection";
import about from "../components/AboutSection";
import download from "../components/DownloadSection";
import contact from "../components/ContactSection";

export default {

    components: {
    navigation,
    home,
    about,
    download,
    contact
    
  },
  
}
</script>
